import { ApolloProvider } from '@apollo/client/react'
import { useWindowEvent } from '@mantine/hooks'
import type { PropsWithChildren } from 'react'
import type { ApolloClientInitialContext } from './client'
import { baseApolloClient, defaultContext } from './client'
import { useGeneratorPreviewSync, usePersonalEventsSync } from './subscriptions'

type RefetchType = 'focus' | 'online'

const refetchQueries = (type: RefetchType) => {
  baseApolloClient.refetchQueries({
    include: 'active',
    onQueryUpdated: query => {
      const context = query.options.context as
        | ApolloClientInitialContext
        | undefined
      if (type === 'focus') {
        return context?.refetchOnFocus ?? defaultContext.refetchOnFocus
      } else if (type === 'online') {
        return context?.refetchOnReconnect ?? defaultContext.refetchOnReconnect
      }
      return false
    },
  })
}

const SubscriptionManager = () => {
  usePersonalEventsSync()
  useGeneratorPreviewSync()
  return null
}

export function ApolloClientProvider(props: PropsWithChildren) {
  useWindowEvent('focus', () => refetchQueries('focus'))
  useWindowEvent('online', () => refetchQueries('online'))
  return (
    <ApolloProvider client={baseApolloClient}>
      <SubscriptionManager />
      {props.children}
    </ApolloProvider>
  )
}
